import axios from "axios";
import ElementUI from 'element-ui'
import { Loading } from 'element-ui';
const instance = axios.create({
  baseURL: 'http://api-web.kdxgs.com/api/',
  timeout: 20000,
});

var loadingInstance
instance.interceptors.request.use(
  (config) => {
    loadingInstance = Loading.service({ fullscreen: true });
    return config;
  },
  (err) => {
    console.log(err)
  }
);

instance.interceptors.response.use(
  (res) => {
    loadingInstance.close();
    if(res.data.status_code!=200){
      ElementUI.Message({
        message: res.data.error_user_msg,
        type: "error"
      })
    }
    return res.data;
  }
);

export default instance;